import { Box, BoxProps, Flex, Text } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useTranslation } from 'next-i18next'
import {
  SelectedCustomizableOption,
  EnteredOptionsCheckOutput,
} from '_app/graphql/generated/graphql'
import { CustomizableEngraveCartItem } from 'modules/checkout/components/PaidOptions'
import CartOptionHeader from './CartOptionHeader'

interface CartProductEngravingProps extends BoxProps {
  wHeading?: BoxProps['w'];
  enteredOptions: EnteredOptionsCheckOutput[];
  customizableOptions: any;
  cartItem: CustomizableEngraveCartItem;
  isDrawerMode?: boolean;
}

const CartProductEngraving: FC<CartProductEngravingProps> = ({
  wHeading,
  enteredOptions,
  customizableOptions,
  cartItem,
  isDrawerMode = false,
  ...props
}) => {
  const { t } = useTranslation()

  const isPainting = enteredOptions.find((opt: any) =>
    opt.label?.toLowerCase().includes('malow')
  )
  const isOnlySizes =
    customizableOptions.filter(option => !option.label.includes('Rozmiar'))
      .length === 0

  if (isOnlySizes) return null

  return (
    <Box py={3} {...props}>
      <Flex w={wHeading || props.w || props.width} mb={2}>
        <Text>{isPainting ? t('PAINTING') : t('ENGRAVING')}</Text>
      </Flex>

      <Flex
        w={props.w || props.width}
        maxW="100%"
        flexWrap="wrap"
        justifyContent="space-between"
        mb={2}
        sx={{
          '&>div:not(:last-child)': {
            paddingBottom: 4,
            marginBottom: 4,
            borderBottom: 'solid 1px',
            borderColor: 'borderLight',
          },
        }}
      >
        <CartOptionHeader
          isPaintingOrEngraving
          cartItem={cartItem}
          isDrawerMode={isDrawerMode}
        />
      </Flex>
    </Box>
  )
}

export default CartProductEngraving
